import {
  artworkByLocale,
  compareStrings,
  displayNamesWithEnTranslation,
  displayTranslations,
  parseCategoryName,
  parseLanguage,
  titleize,
  TRANSLATION_NOTICES
} from "../../utils/utils";
import ShowBlueprintImageFrontImage from "./ShowBlueprintImageFrontImage";
import GameNameParser from "./GameNameParser";
import React, { useState } from "react";
import ExpansionIcon from "./ExpansionIcon";
import LanguageFlag from "./LanguageFlag";

const NameLine = ({ text, parenthesized }) => (
  TRANSLATION_NOTICES.includes(text)
    ? <small className="text-nowrap color-dark-orange">{text}</small>
    : <React.Fragment>{parenthesized ? `(${text})` : text}</React.Fragment>
)

const  BlueprintImageTableRaw = ({
    blueprintImage,
    handleShowLargeImage,
    hideGame,
    id,
    displayEra,
    compact,
    setFlawsToInspect,
    webCamModalHandler,
    displayBlueprintImageColumn,
  }) => {

  const blueprintImageNames = displayNamesWithEnTranslation(blueprintImage.en_name, blueprintImage.meta_name)
  const artworkNames = displayNamesWithEnTranslation(
    blueprintImage.artworks?.artwork_eng,
    artworkByLocale(blueprintImage, blueprintImage.language?.toLowerCase())
  )
  const eraNames = displayTranslations(blueprintImage.en_era_name, blueprintImage.era_name, blueprintImage.language)
  const expansionNames = displayNamesWithEnTranslation(blueprintImage.en_expansion_name, blueprintImage.expansion_name)

  const blueprintOnlyImage = {
    ...blueprintImage,
    thumb_image_url: blueprintImage.blueprint_thumb_image_url,
    xx_large_image_url: blueprintImage.blueprint_xx_large_image_url
  }



  return (
    <React.Fragment>
      <td className="text-center">
        <ShowBlueprintImageFrontImage
          size={"thumb"}
          blueprintImage={blueprintImage}
          handleShowLargeImage={handleShowLargeImage}
          additionalClasses={blueprintImage.is_graded_image ? (blueprintImage.blueprint?.category?.name?.toLowerCase() === 'booster pack' ? "thumb-image-graded-booster-pack m-auto" : "thumb-image-graded-card m-auto") : ''}
          setFlawsToInspect={setFlawsToInspect}
        />
        { webCamModalHandler && blueprintImage.state !== 'graded' &&
          <button
            className="btn btn-secondary btn-sm mt-2"
            onClick={() => webCamModalHandler(blueprintImage)}
          >
            <i className="fas fa-camera mr-2"></i>
            Change Image
          </button>
        }
      </td>
      {
        displayBlueprintImageColumn &&
        <td className="text-center">
          <ShowBlueprintImageFrontImage
            size={"thumb"}
            blueprintImage={blueprintOnlyImage}
            handleShowLargeImage={handleShowLargeImage}
          />
        </td>
      }
      <td className="text-left ml-td">
        <div className={`mb-0 ${compact ? 'text--size-small' : ''}`}>
          <div className="d-flex align-items-center">
            <span className="mr-2">
              { parseLanguage(blueprintImage.language_filter) }
            </span>

            <LanguageFlag
              language={blueprintImage.language}
              maxHeight={'15px'}
            />
          </div>
        </div>
        <p className={`mb-0 ${compact ? 'text--size-small' : ''}`}>{titleize(blueprintImage.version)}</p>
        {
          blueprintImage.rarity && !compareStrings(blueprintImage.rarity, 'no rarity') &&
          <React.Fragment>
            <span className={`mb-0 ${compact ? 'text--size-small' : ''}`}>{titleize(blueprintImage.rarity)}</span>
            {
              blueprintImage.rarity_logo_url &&
                <img src={blueprintImage.rarity_logo_url} alt="" className="ml-1 mb-1"
                     style={{ maxWidth: "15px" }} />
            }
          </React.Fragment>
        }
        {blueprintImage.edition && blueprintImage.edition !== "Undefined" &&
          <p className={`${compact ? 'text--size-small' : ''}`}>{blueprintImage.edition}</p>
        }
      </td>
      <td className="text-center ml-td">
        {blueprintImageNames.length > 1 ?
          <React.Fragment>
            <p className={`mb-0 ${compact ? 'text--size-small' : ''}`}>
              <NameLine text={blueprintImageNames[0]} />
            </p>
            <p className="text--size-small">
              <NameLine text={blueprintImageNames[1]} parenthesized />
            </p>
          </React.Fragment>
          :
          <p id={"name_" + id} className={`${compact ? 'text--size-small' : ''}`}>
            { blueprintImageNames[0] }
          </p>
        }
        <p className={`${compact ? 'text--size-small' : ''}`}>{blueprintImage.collector_number}</p>

        {
          artworkNames[0] ?
            <React.Fragment>
              <p className={artworkNames.length > 1 ? 'mb-0' : ''}>
                <small>
                  {
                    TRANSLATION_NOTICES.includes(artworkNames[0]) ?
                      <NameLine text={artworkNames[0]} /> : `[${artworkNames[0]}]`
                  }
                </small>
              </p>
              {
                artworkNames.length > 1 &&
                <p className="text--size-small"><small><NameLine text={artworkNames[1]} parenthesized /></small></p>
              }
            </React.Fragment>
            : <React.Fragment></React.Fragment>
        }

        {
          blueprintImage.print_sheet_code &&
            <p><small>{blueprintImage.print_sheet_code}</small></p>
        }
      </td>
      {
        compact ?
          <React.Fragment>
            <td className="text-center ml-td text-nowrap">
              {
                !hideGame &&
                <p className="text--size-small">
                  <GameNameParser
                    game_name={blueprintImage.game.name}
                    additionalClasses1={"mb-0"}
                  />
                </p>
              }
              {
                displayEra &&
                  <React.Fragment>
                    {
                      (blueprintImage.en_era_name || blueprintImage.era_name) &&
                      <small>
                        {
                          eraNames.length > 1 ?
                            <React.Fragment>
                              <p className="mb-0">
                                { eraNames[0] }
                              </p>
                              <p className="text--size-small">
                                ({ eraNames[1] })
                              </p>
                            </React.Fragment>
                            :
                            <p className="mb-0">
                              { eraNames[0] }
                            </p>
                        }<br/>
                      </small>
                    }
                  </React.Fragment>
              }
              {
                expansionNames.length > 1 ?
                  <small>
                    <p className="mb-0">
                      <NameLine text={expansionNames[0]} />
                    </p>
                    <p className="text--size-small">
                      <NameLine text={expansionNames[1]} parenthesized />
                    </p>
                  </small>
                  :
                  <small>
                    { expansionNames[0] }
                  </small>
              }

              <ExpansionIcon
                icon_url={blueprintImage.expansion.icon_url}
                width={"25px"}
              />
              <p className="text--size-small">
                { parseCategoryName(blueprintImage.blueprint.category.name) }
              </p>
            </td>
          </React.Fragment>
        :
          <React.Fragment>
            {
              !hideGame &&
              <td className="text-center ml-td">
                <GameNameParser
                  game_name={blueprintImage.game.name}
                  additionalClasses1={"mb-0"}
                />
              </td>
            }
            <td className="text-center ml-td">
              {parseCategoryName(blueprintImage.blueprint.category.name)}
            </td>
            {
              displayEra &&
              <td className="text-center ml-td">
                {
                  (blueprintImage.en_era_name || blueprintImage.era_name) &&
                  <React.Fragment>
                    {
                      eraNames.length > 1 ?
                        <React.Fragment>
                          <p className="mb-0">
                            { eraNames[0] }
                          </p>
                          <p className="text--size-small">
                            ({ eraNames[1] })
                          </p>
                        </React.Fragment>
                        :
                        <p className="mb-0">
                          { eraNames[0] }
                        </p>
                    }
                  </React.Fragment>
                }
              </td>
            }

            <td className="text-center">
              {
                expansionNames.length > 1 ?
                  <React.Fragment>
                    <p className="mb-0">
                      <NameLine text={expansionNames[0]} />
                    </p>
                    <p className="text--size-small">
                      <NameLine text={expansionNames[1]} parenthesized />
                    </p>
                  </React.Fragment>
                  :
                  <p>
                    { expansionNames[0] }
                  </p>
              }

              <ExpansionIcon
                icon_url={blueprintImage.expansion.icon_url}
                width={"25px"}
              />
            </td>
          </React.Fragment>
      }
    </React.Fragment>
  );
}

export default  BlueprintImageTableRaw;
